import { Adapter } from '@mode-switch/adapt';
import { Ident } from '@mode-switch/express';
import { PivotQuery } from './PivotQuery';
import { Query } from './Query';
export var PagedPlan;
(function (PagedPlan) {
    function make(adapter, model, viewName, query) {
        let markFields = [];
        switch (query.type) {
            case "BASIC": {
                markFields = [...PivotQuery.Marks.fields(query.marks || {})];
                break;
            }
            case "DETAIL": {
                markFields = (query.series || []).reduce((fields, series) => {
                    return [...fields, ...PivotQuery.Marks.fields(series.marks || {})];
                }, []);
                break;
            }
        }
        const { filters, sorts, limit, offset } = query;
        const column = new Map();
        const x = new Map();
        const row = new Map();
        const y = new Map();
        const marks = new Map();
        for (const field of query.column || []) {
            column.set(field.alias, field);
        }
        for (const field of query.x || []) {
            x.set(field.alias, field);
        }
        for (const field of query.row || []) {
            row.set(field.alias, field);
        }
        for (const field of query.y || []) {
            y.set(field.alias, field);
        }
        for (const field of markFields) {
            marks.set(field.alias, field);
        }
        const pivot = Query.Pivot.make({
            name: 'pivot',
            sorts,
            filters,
            limit,
            offset,
            column: Array.from(column.values()),
            x: Array.from(x.values()),
            row: Array.from(row.values()),
            y: Array.from(y.values()),
            marks: Array.from(marks.values()),
        });
        const from = Query.Pivot.make({
            name: 'count_from',
            sorts,
            filters,
            column: Array.from(column.values()),
            x: Array.from(x.values()),
            row: Array.from(row.values()),
            y: Array.from(y.values()),
            marks: Array.from(marks.values()),
        });
        const count = Query.Pivot.make({
            name: 'count',
            from,
            marks: [
                Adapter.Fields.make(adapter, model, viewName, 'SUM(1)', "CONTINUOUS", { alias: 'count' }),
            ],
        });
        const id = Ident.next();
        const paged = {
            id,
            model,
            viewName,
            queries: [count, pivot],
            type: "PAGED",
        };
        return paged;
    }
    PagedPlan.make = make;
})(PagedPlan || (PagedPlan = {}));
